import type { CheckBatchTotals } from '../types';
import { formatMoney } from '../format';

/** The blue totals bar. Every figure is the server's total over the included employees — never typed in or re-added here. */
export function SummaryBar({ totals }: { totals: CheckBatchTotals }) {
  return (
    <dl className="wc-summary" data-testid="summary-bar">
      <div><dt>Employees Selected</dt><dd data-testid="summary-employees">{totals.employeesIncluded}</dd></div>
      <div><dt>Gross Pay Total</dt><dd data-testid="summary-gross">{formatMoney(totals.grossTotal)}</dd></div>
      <div><dt>Net Pay Total</dt><dd data-testid="summary-net">{formatMoney(totals.netTotal)}</dd></div>
      <div><dt>Check Total</dt><dd data-testid="summary-check">{formatMoney(totals.checkTotal)}</dd></div>
      <div><dt>Check Delivery</dt><dd>Not enabled</dd></div>
    </dl>
  );
}
